import React, { useState } from 'react';
import { Accordion as BootstrapAccordion, Card } from 'react-bootstrap';

import { BulletIcon } from '../BulletIcon/BulletIcon';
import styles from './Accordion.module.scss';

/**
* 
*
* @param {Array} items - Array of objects with the following structure:
*       @param {string} items[].title - Header text for the accordion item
*       @param {ReactNode} items[].content - Content to be displayed when item is expanded
* @param {string} activeKey default null - Key of the initially expanded accordion item
* @param {boolean} primary default false - Use primary styling instead of neutral
* @param {Function} onToggle - Callback fired when an item is toggled
 */
export const Accordion = ({ items, activeKey = null, primary=true, importedStyle="neutral", onToggle=null }) => {

    const [localKey, setLocalKey]=useState(activeKey);
    const [style, setStyle]=useState(primary===true ? "primary" : importedStyle)

    const handleSelect=(item, index)=>{
        if(localKey===index) setLocalKey(null)
        else setLocalKey(index.toString())
        if(onToggle) onToggle(item, index);
    }

    return (
        <BootstrapAccordion defaultActiveKey={localKey} className={styles["accordion-wrapper"]}>
            {items?.map((item, index) => (
                <React.Fragment key={`accordion-item-${index}`} >
                    {item?.title && item?.content &&
                        <>
                            {(style==="neutral" || style==="primary") &&
                                <Card className={`${styles["overall-item"]} ${styles[style]}`}>
                                    <BootstrapAccordion.Toggle 
                                        onClick={()=>handleSelect(item, index.toString())}
                                        as={Card.Header} 
                                        eventKey={index.toString()}
                                        className={`${styles["card-toggle"]} ${styles[style]}`}
                                    >
                                        <span>{item?.title}</span>
                                        {localKey === index?.toString() ? <BulletIcon bulletType="upCaret" /> : <BulletIcon bulletType="downCaret" />}
                                    </BootstrapAccordion.Toggle>
                                    <BootstrapAccordion.Collapse eventKey={index.toString()} className={styles["collapse-portion"]}>
                                        <Card.Body>
                                            {item?.content}
                                        </Card.Body>
                                    </BootstrapAccordion.Collapse>
                                </Card>
                            }
                            {style==="list" &&
                                <div>
                                    <BootstrapAccordion.Toggle
                                        onClick={()=>handleSelect(item, index.toString())}
                                        eventKey={index.toString()}
                                        className={`${styles["list-toggle"]}`}
                                    >
                                        {localKey === index?.toString() ? 
                                            <BulletIcon bulletType="downCaret" /> 
                                            :
                                            <BulletIcon bulletType="rightCaret" /> 
                                        }
                                        {item.title}

                                    </BootstrapAccordion.Toggle>
                                    <BootstrapAccordion.Collapse eventKey={index?.toString()}>
                                        {item?.content}
                                    </BootstrapAccordion.Collapse>
                                </div>
                            }
                        </>
                    }
                </React.Fragment>
            ))}
        </BootstrapAccordion>
    );
};
